"use strict";

exports.__esModule = true;
exports.TransformMode = exports.BoneData = void 0;

var _Utils = require("./Utils");

/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated January 1, 2020. Replaces all prior versions.
 *
 * Copyright (c) 2013-2020, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/

/** Stores the setup pose for a {@link Bone}. */
var BoneData = function BoneData(index, name, parent) {
  /** The index of the bone in {@link Skeleton#getBones()}. */
  this.index = 0;
  /** The name of the bone, which is unique across all bones in the skeleton. */

  this.name = null;
  /** @returns May be null. */

  this.parent = null;
  /** The bone's length. */

  this.length = 0;
  /** The local x translation. */

  this.x = 0;
  /** The local y translation. */

  this.y = 0;
  /** The local rotation. */

  this.rotation = 0;
  /** The local scaleX. */

  this.scaleX = 1;
  /** The local scaleY. */

  this.scaleY = 1;
  /** The local shearX. */

  this.shearX = 0;
  /** The local shearX. */

  this.shearY = 0;
  /** The transform mode for how parent world transforms affect this bone. */

  this.transformMode = TransformMode.Normal;
  /** When true, {@link Skeleton#updateWorldTransform()} only updates this bone if the {@link Skeleton#skin} contains this
    * bone.
    * @see Skin#bones */

  this.skinRequired = false;
  /** The color of the bone as it was in Spine. Available only when nonessential data was exported. Bones are not usually
   * rendered at runtime. */

  this.color = new _Utils.Color();
  if (index < 0) throw new Error("index must be >= 0.");
  if (!name) throw new Error("name cannot be null.");
  this.index = index;
  this.name = name;
  this.parent = parent;
};
/** Determines how a bone inherits world transforms from parent bones. */


exports.BoneData = BoneData;
var TransformMode;
exports.TransformMode = TransformMode;

(function (TransformMode) {
  TransformMode[TransformMode["Normal"] = 0] = "Normal";
  TransformMode[TransformMode["OnlyTranslation"] = 1] = "OnlyTranslation";
  TransformMode[TransformMode["NoRotationOrReflection"] = 2] = "NoRotationOrReflection";
  TransformMode[TransformMode["NoScale"] = 3] = "NoScale";
  TransformMode[TransformMode["NoScaleOrReflection"] = 4] = "NoScaleOrReflection";
})(TransformMode || (exports.TransformMode = TransformMode = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUE2QkE7O0FBN0JBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQStCQTtJQUNhQSxRLEdBOENaLGtCQUFhQyxLQUFiLEVBQTRCQyxJQUE1QixFQUEwQ0MsTUFBMUMsRUFBMEQ7RUE3QzFEO0VBQ0EsYUFBZ0IsQ0FBaEI7RUFFQTs7RUFDQSxZQUFlLElBQWY7RUFFQTs7RUFDQSxjQUFtQixJQUFuQjtFQUVBOztFQUNBLGNBQWlCLENBQWpCO0VBRUE7O0VBQ0EsU0FBSSxDQUFKO0VBRUE7O0VBQ0EsU0FBSSxDQUFKO0VBRUE7O0VBQ0EsZ0JBQVcsQ0FBWDtFQUVBOztFQUNBLGNBQVMsQ0FBVDtFQUVBOztFQUNBLGNBQVMsQ0FBVDtFQUVBOztFQUNBLGNBQVMsQ0FBVDtFQUVBOztFQUNBLGNBQVMsQ0FBVDtFQUVBOztFQUNBLHFCQUFnQkMsYUFBYSxDQUFDQyxNQUE5QjtFQUVBOzs7O0VBR0Esb0JBQWUsS0FBZjtFQUVBOzs7RUFFQSxhQUFRLElBQUlDLFlBQUosRUFBUjtFQUdDLElBQUlMLEtBQUssR0FBRyxDQUFaLEVBQWUsTUFBTSxJQUFJTSxLQUFKLENBQVUscUJBQVYsQ0FBTjtFQUNmLElBQUksQ0FBQ0wsSUFBTCxFQUFXLE1BQU0sSUFBSUssS0FBSixDQUFVLHNCQUFWLENBQU47RUFDWCxLQUFLTixLQUFMLEdBQWFBLEtBQWI7RUFDQSxLQUFLQyxJQUFMLEdBQVlBLElBQVo7RUFDQSxLQUFLQyxNQUFMLEdBQWNBLE1BQWQ7QUFDQSxDO0FBR0Y7Ozs7QUFDQSxJQUFZQyxhQUFaOzs7QUFBQSxXQUFZQSxhQUFaLEVBQXlCO0VBQUdBO0VBQVFBO0VBQWlCQTtFQUF3QkE7RUFBU0E7QUFBcUIsQ0FBM0csRUFBWUEsYUFBYSw2QkFBYkEsYUFBYSxNQUF6QiIsIm5hbWVzIjpbIkJvbmVEYXRhIiwiaW5kZXgiLCJuYW1lIiwicGFyZW50IiwiVHJhbnNmb3JtTW9kZSIsIk5vcm1hbCIsIkNvbG9yIiwiRXJyb3IiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0JvbmVEYXRhLnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19